 document.addEventListener("DOMContentLoaded", function() {
  const modal = document.getElementById("add-to-product-modal");
  const closeModalBtn = document.getElementById("close-btn");
  const detailsButtons = document.querySelectorAll(".details-product");
  const metafieldsContainer = document.getElementById("product-metafields"); // ✅ Correction ici

  if (!modal || !closeModalBtn || !metafieldsContainer || detailsButtons.length === 0) {
    // console.error("❌ Un élément est introuvable. Vérifie ton HTML.");
    return;
  }

  // Ouvrir la modal et charger les Metafields du produit sélectionné
  detailsButtons.forEach(button => {
    button.addEventListener("click", function() {
      const productId = this.getAttribute("data-product-id");
      const productTitle = this.getAttribute("data-product-title");
      const productPrintType = this.getAttribute("data-product-print-type");
      const productWifi = this.getAttribute("data-product-wifi");
      const productUsb = this.getAttribute("data-product-usb");
      const productFax = this.getAttribute("data-product-fax");
      const productUrl = this.getAttribute("data-product-url");

      //console.log(`🛍️ Chargement des Metafields pour le produit ID: ${productId}`);

      // Vérification si les valeurs sont null
      metafieldsContainer.innerHTML = `
        <div class="popup">
          <div class="popup-content">
            <table class="styled-table">
              <tbody>
                <tr>
                  <td class="small-column"><strong>Produit</strong></td>
                  <td><strong>${productTitle}</strong></td>
                </tr>
                <tr>
                  <td class="small-column">Type d'impression</td>
                  <td>${productPrintType || "Non spécifié"}</td>
                </tr>
                <tr>
                  <td class="small-column">Wi-Fi</td>
                  <td>${productWifi || "Non spécifié"}</td>
                </tr>
                <tr>
                  <td class="small-column">USB</td>
                  <td>${productUsb || "Non spécifié"}</td>
                </tr>
                <tr>
                  <td class="small-column">Fax</td>
                  <td>${productFax || "Non spécifié"}</td>
                </tr>
              </tbody>
            </table>
            <a href="${productUrl}">PLus de détails</a>
          </div>
        </div>
      `;


      // Afficher la modal
      modal.classList.add("active");
    });
  });

  // Fermer la modal avec le bouton
  closeModalBtn.addEventListener("click", () => {
    modal.classList.remove("active");
  });

  // Fermer la modal en cliquant en dehors
  modal.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.classList.remove("active");
    }
  });

  // Fermer la modal avec la touche Échap
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("active")) {
      modal.classList.remove("active");
    }
  });
});
